var _g, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserBlockedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1449 34H57.3859C60.2539 34 62.8279 31.918 63.1169 29.064C63.4479 25.789 60.8559 23 57.6449 23H38.3149C36.6909 23 35.2339 21.784 35.1499 20.161C35.0589 18.431 36.4349 17 38.1449 17H43.3859C46.2539 17 48.8279 14.918 49.1169 12.064C49.4479 8.789 46.8559 6 43.6449 6H32.1449H24.6449H9.64491C6.60691 6 4.14491 8.462 4.14491 11.5C4.14491 14.538 6.60691 17 9.64491 17H13.1449C14.2499 17 15.1449 17.895 15.1449 19C15.1449 20.105 14.2499 21 13.1449 21H5.85691C3.50991 21 1.40391 22.704 1.16791 25.038C0.896913 27.718 3.01791 30 5.64491 30H11.9749C13.5989 30 15.0559 31.216 15.1399 32.839C15.2309 34.569 13.8549 36 12.1449 36H8.85691C6.50991 36 4.40391 37.704 4.16791 40.038C3.89791 42.718 6.01791 45 8.64491 45H13.0379C14.0339 45 14.9579 45.681 15.1179 46.664C15.3209 47.917 14.3599 49 13.1449 49H8.85691C6.50991 49 4.40391 50.704 4.16791 53.038C3.89691 55.718 6.01791 58 8.64491 58H30.6449C30.7309 58 30.8109 57.979 30.8949 57.975C30.9789 57.982 31.0589 58 31.1449 58H48.5309C50.2009 58 51.7259 56.878 52.0679 55.243C52.5369 52.998 50.8129 51 48.6449 51H43.2519C42.2559 51 41.3319 50.319 41.1719 49.336C40.9689 48.083 41.9299 47 43.1449 47H55.4329C57.7799 47 59.8859 45.296 60.1219 42.961C60.3919 40.282 58.2719 38 55.6449 38H52.2519C51.2559 38 50.3319 37.319 50.1719 36.336C49.9689 35.083 50.9299 34 52.1449 34Z",
    fill: "url(#paint0_radial_4090:49603)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5761 36.9568C37.2585 36.9568 41.0545 33.1609 41.0545 28.4784C41.0545 23.7959 37.2585 20 32.5761 20C27.8936 20 24.0977 23.7959 24.0977 28.4784C24.0977 33.1609 27.8936 36.9568 32.5761 36.9568Z",
    stroke: "#2F189C",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7266 44.3744C21.0295 42.1191 22.9031 40.2464 25.1589 38.9444C27.4148 37.6424 29.9736 36.957 32.5782 36.957C35.1829 36.9571 37.7417 37.6425 39.9975 38.9445C42.2534 40.2466 44.1269 42.1193 45.4298 44.3747",
    stroke: "#2F189C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4090:49603",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1449 32) scale(28.609)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#BBF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1FAFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlockedIcon);
export default __webpack_public_path__ + "static/media/user-blocked-icon.48476298.svg";
export { ForwardRef as ReactComponent };